module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAABU0lEQVQYGW3Bz2sNAAAH8K892prSHMiWbFHiLhQ5WDtILQ7SivxILYSSsotyYuUkJ2qzMn8BJdKmVnuiVzLlIIn8OHiKrceaw8fbLO9t+XxSo9FZYyZ981B3/kebF0qO2GaX8z4aVshinhqwJPO0KLmRhRwyoZA4qeiRrkS7ivWpZ9TxRJ83elxQ0Zm4pT81CqZsUPDdllQ57UGix5PUWIkWTX5bkyr7PE90eZkajaatS9w3pFmrkr7EAcXUM6o3sdq4nyqGNCQG9aeewyYyx1qrUqXNLx1ZyGunUsewO1nMbpM6Mk+3stYspsFVryxPlY0mdWtJPUeNmNLhsRGN2r13WacZ485YmlkGfHXFzkSzMSVvXU+VrS754F5mKbumKXMsc9Gx/OOcSmbp8kXZoF577bDZJtvtccJN75QdzF+a7Xdb0Sc/TJsx5bNn7uqxIlV/AP9UBgzrg5VWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/bottom_address.png
// module id = yA8q
// module chunks = 32